import { Stack, Tabs, Typography } from "@mui/material";
import { customerBusiness } from "api/bussiness/customer/customer-bussiness";
import { CustomerPermission } from "commons/enum/permission";
import { observer } from "mobx-react-lite";
import { IContactInformation } from "mobx-stores/_models/customers/contact-information";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  AddButton,
  EditButton,
  GoBackIconButton,
  RemoveButton,
} from "share-components/mui-wrap/button/action-button";
import { XTab } from "share-components/mui-wrap/tab/x-tab";
import { PageContentScrollableContainer } from "share-components/templates/page/page-content-container";
import { PageDetailContainer } from "share-components/templates/page/page-detail-container";
import { PageHeaderContainer } from "share-components/templates/page/page-header-container";
import { AddContact } from "../contacts/add-contact";
import { Contacts } from "../contacts/contacts";
import { EditContact } from "../contacts/edit-contact";
import { EditCustomer } from "../edit-customer/edit-customer";
import { DetailInformationAsTable } from "./detail-information";

export const CustomerDetail = observer(() => {
  const {
    customerManagement: {
      getCustomerDetail,
      customerDetail,
      openEdit,
      contactManagement,
    },
  } = useStores();
  const [tab, setTab] = useState<"basic" | "contacts">("basic");
  const { customerId } = useParams();
  useEffect(() => {
    if (customerId) {
      getCustomerDetail(customerId);
    }
  }, [customerId, getCustomerDetail]);
  return (
    <PageDetailContainer>
      <PageHeaderContainer direction={"row"} justifyContent={"space-between"}>
        <Header tabSelected={tab}></Header>
      </PageHeaderContainer>
      <Tabs
        value={tab}
        onChange={(_, value) => {
          setTab(value);
        }}
      >
        <XTab label="Khách hàng" value={"basic"} />
        <XTab label="Liên hệ" value={"contacts"} />
      </Tabs>
      <PageContentScrollableContainer>
        {tab === "basic" && (
          <DetailInformationAsTable></DetailInformationAsTable>
        )}

        {tab === "contacts" && (
          <Contacts
            contactInformations={
              customerDetail?.contactInformations as IContactInformation[]
            }
          ></Contacts>
        )}
      </PageContentScrollableContainer>

      <>
        {openEdit && <EditCustomer></EditCustomer>}
        {contactManagement.openNew && <AddContact></AddContact>}
        {contactManagement.openEdit && <EditContact></EditContact>}
      </>
    </PageDetailContainer>
  );
});
type HeaderProps = {
  tabSelected: "basic" | "contacts";
};
const Header = observer(({ tabSelected = "basic" }: HeaderProps) => {
  const {
    customerManagement: {
      customerDetail,
      setProp: setCustomerManagementProp,
      contactManagement,
    },
    deleteConfirmationStore: { setProp, setDeletionCallback },
  } = useStores();
  const navigate = useNavigate();
  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);
  const onDelete = useCallback(
    async (id: string) => {
      if (id) {
        await customerBusiness.delete(id);
        goBack();
      }
    },
    [goBack]
  );
  const removeHandler = useCallback(() => {
    setProp("open", true);
    setDeletionCallback(() => {
      if (!customerDetail?.id) return;
      onDelete(customerDetail?.id);
    });
  }, [customerDetail, onDelete, setDeletionCallback, setProp]);

  const editHandler = useCallback(() => {
    setCustomerManagementProp("openEdit", true);
  }, [setCustomerManagementProp]);

  const addMoreContact = useCallback(() => {
    contactManagement.setProp("openNew", true);
  }, [contactManagement]);
  return (
    <>
      <Stack
        direction={"row"}
        justifyItems={"center"}
        spacing={1}
        alignItems={"center"}
      >
        <GoBackIconButton onClick={goBack}></GoBackIconButton>
        <Typography variant="subtitle2">{`Thông tin chi tiết `}</Typography>
      </Stack>
      <Stack direction={"row"} justifyItems={"center"} spacing={1}>
        {tabSelected === "basic" && (
          <>
            <RemoveButton
              accessPermission={[CustomerPermission.Delete]}
              onClick={removeHandler}
            ></RemoveButton>
            <EditButton
              accessPermission={[CustomerPermission.Update]}
              onClick={editHandler}
            ></EditButton>
          </>
        )}
        {tabSelected === "contacts" && (
          <>
            <AddButton
              accessPermission={[CustomerPermission.Create]}
              onClick={addMoreContact}
            >
              Thêm liên hệ
            </AddButton>
          </>
        )}
      </Stack>
    </>
  );
});
